module.exports = __webpack_public_path__ + "static/media/profile.14b96dde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/profile.svg
// module id = 1102
// module chunks = 0